import { render, staticRenderFns } from "./UserRegistration.html?vue&type=template&id=46664beb&external"
import script from "./UserRegistration.vue?vue&type=script&lang=js"
export * from "./UserRegistration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports